import React, {useEffect, useState} from "react";
import Modal from "../../../components/Modal/Modal";
import {GenerateForm} from "../../../components/cardViewComponents/GenerateForm";
import {validationData} from "../../../components/UI/formValid";
import {validationConfig} from "../../../components/cardViewComponents/validationConfig";
import Notif from "../../../components/Notif";
import myaxios from "../../../components/Axios";
import {formatDate} from "../../../components/ListComponent";

const fieldsConfig = {
    name: {
        label: 'Название',
        type: 'text',
        className: 'w100',
        validation: { required: true, maxLength: 255 }, zone: 1
    },
    from_id: {
        label: 'Со склада',
        type: 'entity',
        link: "/ajax/stock?filter[name][like]=",
        result: 'name',
        entity_from: 'from',
        entityName: 'name',
        className: 'w100',
        minLength: 0,
        validation: { required: true }, zone: 1
    },
    to_id: {
        label: 'На склад',
        type: 'entity',
        link: "/ajax/stock?filter[name][like]=",
        result: 'name',
        entity_from: 'to',
        entityName: 'name',
        className: 'w100',
        minLength: 0,
        validation: { required: true }, zone: 1
    },
    date: {
        label: 'Дата перемещения',
        type: 'date',
        className: 'w100',
        validation: { maxLength: 255 }, zone: 1
    },
}

export const TransferModal = ({ isOpen, close, history }) => {
    const [loading, setLoading] = useState(true)
    const [errors, setErrors] = useState({})
    const [disabled, setDisabled] = useState({})
    const [values, setValues] = useState({
        name: '',
        from_id: null,
        from: null,
        to_id: null,
        to: null,
        date: null,
        tch: true
    })

    const getPrepare = async () => {
        const { status, data } = await myaxios.get(`/ajax/stock/transfer/prepare`)
        if((status === 200 || status === 201) && data) {
            setValues({
                ...values,
                date: formatDate(new Date()),
                name: 'Перемещение №' + data.nextId
            })
        }
        setLoading(false)
    }

    const saveItem = async () => {
        const errorsData = validationData(values, validationConfig(fieldsConfig));
        setErrors(errorsData)
        if(Object.keys(errorsData).length > 0) {
            Notif('required-fields')
            return false;
        }

        if(values.from_id === values.to_id) {
            Notif('required-fields', 'Запрещено переносить продукты на тот же склад')
            return false
        }

        setLoading(true)
        const { name, from_id, to_id, date } = values
        const { status, data } = await myaxios.post(`/ajax/stock/transfer`, { name, from_id, to_id, date })
        if((status === 200 || status === 201) && data.id) {
            history.push(`/stock/transfer/${data.id}`)
        }
        setLoading(false)
    }

    useEffect(() => {
        getPrepare().then()
    }, [])

    const changeFields = (key, value, item) => {
        let obj = {}
        if(item) {
            if(item === 'clear') obj[fieldsConfig[key].entity_from] = null
            else obj[fieldsConfig[key].entity_from] = item
        }

        setValues({ ...values, ...obj, [key]: item ? item.id : value, tch: false })
    }

    return (
        <Modal isOpen={isOpen} save={saveItem} close={close} loading={loading} showLeaveModal tch={values.tch} title={'Создать перемещение'}>
            <GenerateForm
                config={fieldsConfig}
                { ...{ values, errors, disabled } }
                onChange={changeFields}
                onSaveData={saveItem}
            />
        </Modal>
    )
}